const Reels = () => {
    return (
      <div className="home">
      Reels
      </div>
    )
  }
  
  export default Reels